<template>
  <div class="container">
    <van-tabs class="top-nav" v-model="curTab" type="card" color="#599d00">
      <van-tab v-for="tab in tabList" :key="tab.name" :to="tab.path" :title="store.langConfig[tab.name]">
      </van-tab>
      <div v-if="showMod">
        <router-view :store="store"></router-view>
      </div>
    </van-tabs>
  </div>
</template>

<script>
import {store} from '@/config/store'
import {getLanguageConfig} from '@/api'

export default {
  name: 'Layout',
  data(){
    return {
      store: store,
      tabList: [{
        name: 'myQuestion',
        path: '/faq',
      }, {
        name: 'customerService',
        path: '/customer'
      }],
      curTab: 0,
      showMod: false
    }
  },
  created(){
    // 提供webview客户端调用
    window.callJS = this.callJS
    // 监听更新横竖屏状态
    this.setScreenState()
    window.addEventListener('orientationchange' in window?'orientationchange':'resize', this.setScreenState)
    
    let SESSION = sessionStorage.getItem('config')
    if (SESSION) {
      this.callJS(SESSION)
    }
    if (this.$route.query.param) {
      this.callJS(this.$base64.decode(this.$route.query.param))
    }
    // this.callJS()
  },
  watch:{
    $route: {
      immediate: true,
      handler(to) {
        this.curTab =this.tabList.findIndex(item=>to.path.includes(item.path))
      }
    }
  },
  methods: {
    // 提供给客户端调用
    callJS(config){
      // console.log('config', config)
      
      // 配置保存到sessionStorage中
      // config = '{"roleId":"123456","isp":"46001","packageId":2,"operatorOs":"android12","language":"en","source":"1","deviceNo":"cb3a7cda-ee23-4065-bdc5-f1255f188739","version":"1.1.3","clientTime":"2023-11-22 15:45:47","userId":67702135,"serverId":"111000","network":0,"vipLevel":"0","appId":"10700","gameUserId":"yk-1176898609265381376","roleName":"测试客服角色","model":"PDCM00","sdkVersion":"2.3.1","packageName":"com.wan.wartuneh5","roleLevel":"10","device":{"googleId":"cb3a7cda-ee23-4065-bdc5-f1255f188739","clientip":"10.0.34.87","imei":"unknown","imsi":"unknown","ua":"Dalvik/2.1.0 (Linux; U; Android 12; PDCM00 Build/SP1A.210812.016)","uuid":"52e4ad1e-ebbd-4bc4-b0a7-15bf0f965bc6","oaid":"","androidid":"a6fc649ca5a5e761","mac":"02:00:00:00:00:00"}}'
      // config = '{"appId":"10700","userId":"150399","roleId":"111111","roleName":"Bys10","level":"11","vipLevel":"1","gameZoneId":"456789","language":"zh-Hans","isp":"46000","packageName":"com.gzlxq.jqcq3","source":1,"operatorOs":"android7.1.2","packageId":"1","network":0,"sdkVersion":"2.1.1.0-SHNAPSHOT","clientTime":"2022-01-05 14:58:16","version":"1.0","deviceNo":"d2af83c5c45af1d1","userChannel":0,"model":"YAL-AL10"}'
      // config = '{"roleLevel":"11","roleId":"9527","userId":"51444292","device":{"uuid":"4F14487E-1DB7-4AB8-A718-49A9A99F1878","idfa":"9095CD05-48A9-43FA-92F8-FB10A9BA898F","idfv":"67A61096-0FB5-40EA-884D-0929058EAE39","clientip":"10.20.32.70","ua":"Mozilla/5.0 (iPhone; CPU iPhone OS 14_8_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148"},"serverId":"server01","roleName":"周星星","vipLevel":"0","language":"zh_CN","appId":"10700","gameUserId":"kingste","deviceNo":"09BA130F-7104-4D48-8D61-85594F754BCC"}'
      //临时修改
      let _config = config ? JSON.parse(config):{}
      if (_config.userId && _config.userId.toString().indexOf('60000_') == 0) {
        _config.userId = _config.userId.slice(6)
        _config.gameUserId = _config.userId
      } else {
        _config.userId = _config.gameUserId
      }
      sessionStorage.setItem('config',JSON.stringify(_config))
      this.store.userInfo = _config
      // console.log('config', _config)


      // sessionStorage.setItem('config',config)
      // this.store.userInfo = config ? JSON.parse(config):{}
      // 获取语言配置
      this.getLanguageConfig()
    },
    // 设置横竖屏
    setScreenState(){
      if (window.orientation === 90 || window.orientation === -90) {
        this.store.screenState = 'landscape'
      }
      if (window.orientation === 0 || window.orientation === 180) {
        this.store.screenState = 'portrait'
      }
    },
    // 获取语言对应配置
    getLanguageConfig(){
      let appId = this.store.userInfo.appId
      let lang = this.store.userInfo.language

      let url = '/v1/config/getConfigLanguages/'+appId+'/'+lang
      getLanguageConfig(url).then(res => {
        let obj = {}
        res.data.forEach(item => {
          obj[item.key] = item.content
        })
        // data中监听数据发生变化才会更新视图
        this.store.langConfig = obj 
        this.store.loading = {
          isShow: false,
          showType: 1
        }
        sessionStorage.setItem('langConfig', JSON.stringify(obj))
        this.showMod = true
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 5px 10px 0;
}

@media screen and (orientation: portrait) {
  .top-nav {
    ::v-deep {
      .van-tabs__wrap {
        height: 35px;
        .van-tabs__nav--card {
          height: 35px;
        }
      }
    }
  }
}
</style>